import debounce from 'debounce'
import React from 'react'

export function useDebounce(
  cb: AnyFunction,
  time: number = 300,
  deps: React.DependencyList = [],
) {
  const debounced = React.useCallback(debounce(cb, time), [...deps, cb, time])

  React.useEffect(() => {
    return () => {
      debounced.clear()
    }
  }, [debounced])

  return debounced
}
